export const getSubdomain = () => {
  const hostname = window.location.hostname;
  

  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'refer') {
    return null;
  }
  const subdomain = hostname.split(".")[0]
  return subdomain;
};

export const getDomain = () => {
  const hostname = window.location.hostname
  const domain = hostname.split(".")[1]
  return domain
}

const logos = {
  teslaCertified: {
    source: 'https://i.imgur.com/pUUKCEd.png',
    height: '200px'
  },
  oneHome: {
    source: 'https://i.imgur.com/DAg1a53.png',
    height: '200px'
  },
  teslaOne: {
    source:'https://i.imgur.com/XVuIZsy.png',
    height: '400px'
  }
}

export const APP_MODES = {
  REFERRAL: 'referral',
  ONBOARDING: 'onboarding',
  INSTALL: 'install'
};

export const SUBDOMAIN_CONFIGS = {
  onboard: {
    mode: APP_MODES.ONBOARDING,
    logo: logos.oneHome,
    defaultReferralType: 'internal', 
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['internal'],
    contactSection: false,
    companyName: '1Solar',
    apiEndpoint: '/api/onboarding/submit', 
    updateEndpoint: '/api/onboarding/update',
    completionOption: 'fill-now',
    labels: {
      mainAction: 'Onboarding',
      referrer: 'Requestor',
      lead: 'New Hire',
      formCompletion: {
        fillNow: 'Complete onboarding now',
        sendLink: 'Send to new hire',
        both: 'Start now, new hire finishes'
      }
    }
  },
  
  install: {
    mode: APP_MODES.INSTALL,
    logo: logos.oneHome,
    defaultReferralType: 'internal',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['internal'],
    contactSection: false,
    companyName: '1Solar',
    apiEndpoint: '/api/install/submit',
    updateEndpoint: '/api/install/update',
    completionOption: 'fill-now',
    labels: {
      mainAction: 'Installation',
      referrer: 'Requestor',
      lead: 'Customer',
      formCompletion: {
        fillNow: 'Schedule installation now',
        sendLink: 'Send to customer',
        both: 'Start now, customer finishes'
      }
    }
  },
  tesla: {
    mode: APP_MODES.REFERRAL,
    logo: logos.teslaOne,
    defaultReferralType: 'self',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['self'],
    companyName: 'Partner Company 1',
    product: 'battery',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    labels: {
      mainAction: 'Referral',
      referrer: 'Referrer',
      lead: 'Lead'
    }
  },
    refer: {
    mode: APP_MODES.REFERRAL,
    logo: logos.oneHome,
    defaultReferralType: 'self',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['self'],
    companyName: '1Solar',
    product: 'battery',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    labels: {
      mainAction: 'Referral',
      referrer: 'Referrer',
      lead: 'Lead'
    }
  },
    savings: {
    mode: APP_MODES.REFERRAL,
    logo: logos.oneHome,
    defaultReferralType: 'self',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['self'],
    companyName: 'Partner Company 1',
    product: 'battery',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    completionOption: 'fill-now',
    labels: {
      mainAction: 'Inquiry',
      referrer: 'Inquirer',
      lead: 'Client'
    }
  },
  sales: {
    mode: APP_MODES.REFERRAL,
    logo: logos.oneHome,
    defaultReferralType: 'self',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['self'],
    companyName: 'Partner Company 1',
    product: 'battery',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    completionOption: 'fill-now',
    labels: {
      mainAction: 'Inquiry',
      referrer: 'Inquirer',
      lead: 'Client'
    }
  },
  employees: {
    mode: APP_MODES.EMPLOYEES,
    logo: logos.oneHome,
    defaultReferralType: 'employee',
    contactSection: false,
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['employee'],
    companyName: '1Solar',
    product: '',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    labels: {
      mainAction: 'Referral',
      referrer: 'Referrer',
      lead: 'Lead'
    }
  },
  
  schedule: {
    mode: APP_MODES.EMPLOYEE,
    logo: logos.oneHome, 
    defaultReferralType: 'employee',
    contactSection: false,
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['employee'],
    companyName: '1Solar',
    product: 'energy-audit',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    labels: {
      mainAction: 'Referral',
      referrer: 'Referrer',
      lead: 'Lead'
    }
  },

  ev: {
    mode: APP_MODES.REFERRAL,
    logo: logos.oneHome, 
    defaultReferralType: 'self',
    hideReferralTypeSelection: true,
    allowedReferralTypes: ['self'],
    companyName: 'car dealership',
    product: 'ev-charger',
    apiEndpoint: '/api/referrals/submit',
    updateEndpoint: '/api/referrals/upload',
    completionOption: 'send-link',
    labels: {
      mainAction: 'Referral',
      referrer: 'Referrer',
      lead: 'Lead'
    }
  }
  
};

let cachedConfig = null;
let cachedSubdomain = null;

export const getSubdomainConfig = () => {
  const subdomain = getSubdomain();
  
  if (cachedSubdomain === subdomain && cachedConfig) {
    return cachedConfig;
  }
  
  console.log(`SubDomain/ host: ${subdomain}`)
  
  let config;
  if (subdomain && SUBDOMAIN_CONFIGS[subdomain]) {
    config = {
      subdomain,
      ...SUBDOMAIN_CONFIGS[subdomain],
    };
  } else {
    config = {
      subdomain: null,
      logo: logos.oneHome,
      defaultReferralType: '',
      hideReferralTypeSelection: false,
      allowedReferralTypes: ['customer', 'self', 'employee', 'partner'],
      companyName: '1Solar',
    };
  }
  
  // Cache the result
  cachedSubdomain = subdomain;
  cachedConfig = config;
  
  return config;
};


export const getFilteredReferralSources = (allSources, config) => {
  if (!config.allowedReferralTypes) {
    return allSources;
  }
  
  return allSources.filter(source => 
    config.allowedReferralTypes.includes(source.id)
  );
};